import { API_BASE_URL } from '../config';

const STORAGE_KEY = 'unipapo_auth';

export function getStoredAuth() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setStoredAuth(payload) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}

export function clearStoredAuth() {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(STORAGE_KEY);
}

export function getToken() {
  return getStoredAuth()?.token || null;
}

export function getTenantId() {
  return getStoredAuth()?.tenant?.id || null;
}

export function getTenantSlug() {
  return getStoredAuth()?.tenant?.slug || null;
}

export async function apiFetch(path, options = {}) {
  const {
    method = 'GET',
    json,
    headers = {},
    tenantId = getTenantId(),
    tenantSlug = getTenantSlug(),
  } = options;

  const finalHeaders = new Headers(headers);
  const token = getToken();
  if (token) finalHeaders.set('Authorization', `Bearer ${token}`);
  if (json) finalHeaders.set('Content-Type', 'application/json');
  const needsTenant = !path.startsWith('/auth/') && path !== '/health';
  if (tenantId) finalHeaders.set('x-tenant-id', tenantId);
  else if (tenantSlug) finalHeaders.set('x-tenant-slug', tenantSlug);
  else if (needsTenant) {
    const err = new Error(
      'Sua conta não está vinculada a um tenant. Faça logout e entre com um usuário de tenant (ex.: contato@brunnoalves.com.br).'
    );
    err.status = 400;
    throw err;
  }

  let res;
  try {
    res = await fetch(`${API_BASE_URL}${path}`, {
      method,
      headers: finalHeaders,
      body: json ? JSON.stringify(json) : undefined,
    });
  } catch (networkError) {
    const msg =
      networkError?.message === 'Failed to fetch'
        ? `Não foi possível conectar à API (URL: ${API_BASE_URL}). Verifique: 1) API rodando (ex.: npm run start em apps/api); 2) VITE_API_URL no .env do front (ex.: VITE_API_URL=http://localhost:3001).`
        : networkError?.message || 'Erro de rede';
    const err = new Error(msg);
    err.status = 0;
    throw err;
  }

  if (res.status === 401) {
    clearStoredAuth();
  }

  const payload = await res.json().catch(() => ({}));
  if (!res.ok) {
    const raw = payload?.message;
    const message = (Array.isArray(raw) ? raw[0] : raw) || payload?.error || 'Erro inesperado';
    const msg = typeof message === 'string' ? message : 'Erro inesperado';
    const err = new Error(msg);
    err.status = res.status;
    err.message = msg;
    throw err;
  }
  // Compatibilidade com API que retorna { data, meta }: expor items/total para o restante do front.
  if (Array.isArray(payload?.data) && payload.meta != null) {
    payload.items = payload.data;
    payload.total = payload.meta.total;
  }
  return payload;
}
